const page   = require('../../../../../components/page/page')
const providercreditDt = require('./providercredit-dt')

import providercreditPage       from "./providercredit-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('providercredit init>')
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", providercreditPage)

   providercreditDt.start({"dest":"providercredit", "elem":"dt", "act":"select", "entity":"providercredit"})

}/*init*/

/****************ELEMENTS*****************/



export function start(detail){ 
   
  // console.log('providercredit page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}




const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},
}